// TenantKyc.jsx
import React, { useEffect, useState } from "react";
import SidebarPopup from "../../Components/SidebarPopup/SidebarPopup";
import { DropDownBox } from "../../Components/SidebarPopup/style";

import { isEmpty } from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";
import {

  getRoomsDetails,
  savePgRoom,
} from "../../utils/api";
import Input from "../../Components/Input/Input";


function TenantKyc({ close = () => { }, userName = "", pgData = null }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [loader, setLoader] = useState(false);

  const [message, setMessage] = useState(null);


  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRoom, setSelectedRoom] = useState(null);







  const initialFromData = {
    roomNumber: "",
    roomCapacity: "",
    remark: "",
    roomCapacityFilled: 0,
    roomId: undefined,
  }


  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => setMessage(null), 5000);
    return () => clearTimeout(timer);
  }, [message]);


  const [formData, setFormData] = useState({ ...initialFromData });

  const [error, setError] = useState({});


  const isFieldEmpty = (val) => val === undefined || val === null || val.toString().trim() === "";
  const isFieldNumber = (val) => /^[0-9\b]+$/.test(val);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "roomCapacity" && value !== "" && !isFieldNumber(value)) return;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const errs = {};
    if (isFieldEmpty(pgData?.uuid)) errs.accommodationId = "Accommodation ID is required";
    if (isFieldEmpty(formData.roomNumber)) errs.roomNumber = "Room Number is required";
    if (isFieldEmpty(formData.roomCapacity)) errs.roomCapacity = "Room Capacity is required";
    setError(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoader(true);

      let payload = {
        accommodationId: pgData?.uuid,
        roomDetails: [
          {
            roomNumber: formData.roomNumber,
            roomCapacity: Number(formData.roomCapacity),
            remark: formData.remark || "",
            roomCapacityFilled: Number(formData?.roomCapacityFilled),
            roomId: formData?.roomId,
          },
        ],
      };
      const actionType = showAddForm ? "add" : "update";
      if (!showAddForm) {

        payload = {
          roomNumber: formData.roomNumber,
          roomCapacity: Number(formData.roomCapacity),
          remark: formData.remark || "",
          roomCapacityFilled: Number(formData?.roomCapacityFilled),
          roomId: formData?.roomId,
          accommodationId: payload.accommodationId,
        }
      }
      const res = await savePgRoom(payload, actionType);


      if (res?.data?.message === "SUCCESS") {
        setMessage({ type: "success", msg: `PG Room ${showAddForm ? "added " : "updated "} successfully` });
        setFormData({
          accommodationId: pgData?.accommodationId || "",
          roomNumber: "",
          roomCapacity: "",
          remark: "",
        });
        fetchUuidAndRooms(pgData?.uuid);
        setShowAddForm(false);
        setSelectedRoom(null);
      } else {
        setMessage({
          type: "error",
          msg: res?.data?.msg || "Failed to save PG Room",
        });
      }
    } catch (err) {
      setMessage({
        type: "error",
        msg: err?.response?.data?.message || err.message || "Error saving PG Room",
      });
    } finally {
      setLoader(false);
    }
  };

  // Close popup handler
  const handleClose = () => {
    close()
  };
  useEffect(() => {

    if (isEmpty(pgData)) return;

    fetchUuidAndRooms(pgData?.uuid);
  }, [pgData]);

  const fetchUuidAndRooms = async (uuid) => {
    try {
      setLoading(true);

      const roomsRes = await getRoomsDetails(uuid);

      if (roomsRes?.data.message === "SUCCESS") {
       const sorted = [...(roomsRes?.data?.data || [])].sort((a, b) =>
  a.roomNumber.localeCompare(b.roomNumber, undefined, { numeric: true })
);
   
        setRooms([...sorted]);
      }

    } catch (err) {
      console.error("Error fetching UUID or room details:", err);
    } finally {
      setLoading(false);
    }
  };




  const formObj = [
    { label: "Room Number", name: "roomNumber" },
    { label: "Room Capacity", name: "roomCapacity" },
    { label: "Room Capacity Filled", name: "roomCapacityFilled" },
    { label: "Remark", name: "remark" },
  ]
  return (
    <div>
      {message && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage(null)}>×</span>
          {message.msg}
        </AlertWrapper>
      )}

      <SidebarPopup
        close={handleClose}
        title="PG"
        randerInput={
          <div></div>
        }

        bodyStyle={{ paddingBottom: "100px" }}
      >
        {(loader || loading) ? (
          <>
            <DropDownBox style={{ height: "164px" }}></DropDownBox>
            <DropDownBox style={{ height: "144px" }}></DropDownBox>
            <DropDownBox style={{ height: "122px" }}></DropDownBox>
          </>
        ) : (
          <>
            <DropDownBox style={{ marginBottom: "20px" }}>
              <h3 style={{ fontWeight: 600, marginBottom: "10px" }}>PG Details</h3>
              {pgData ? (
                <>
                  <div className="kycolumn">
                    <h4 className="title">Owner Name</h4>
                    <span className="value">
                      {pgData?.ownerName || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Owner Parent Name</h4>
                    <span className="value">
                      {pgData?.ownerParentName || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Contact Number</h4>
                    <span className="value">
                      {pgData?.contactNumber || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Address</h4>
                    <span className="value">
                      {pgData?.addressLine || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Address</h4>
                    <span className="value">
                      {pgData?.addressLine || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Locality</h4>
                    <span className="value">
                      {pgData?.locality || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Police Station</h4>
                    <span className="value">
                      {pgData?.policeStation || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">City</h4>
                    <span className="value">
                      {pgData?.city || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">State</h4>
                    <span className="value">
                      {pgData?.state || "NA"}
                    </span>
                  </div>
                  <div className="kycolumn">
                    <h4 className="title">Postal Code</h4>
                    <span className="value">
                      {pgData?.postalCode || "NA"}
                    </span>
                  </div>


                </>

              ) : (
                <span>No PG details found</span>
              )}
            </DropDownBox>

            <DropDownBox>
              <h2 style={{ marginBottom: "10px" }}> Rooms</h2>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                {!isEmpty(rooms) &&
                  rooms.map((room, index) => {
                    const isRoomAvailable = !room.isRoomAvailable;

                    return (
                      <div
                        key={room.roomId}
                        onClick={() => {
                          setFormData({ ...room });
                          setSelectedRoom(room);
                          setShowAddForm(false);


                        }}
                        style={{
                          border: selectedRoom?.roomId === room.roomId ? "2px solid blue" : "1px solid #ccc",
                          borderRadius: "10px",
                          padding: "10px",
                          width: "80px",
                          textAlign: "center",
                          backgroundColor: isRoomAvailable ? "#e0e0e0" : "#fff",
                          color: isRoomAvailable ? "#aaa" : "#000",
                          cursor:  "pointer",
                          position: "relative",
                        }}
                      >
                        <div style={{ fontWeight: "bold", marginBottom: "8px" }}>{room.roomNumber || index + 1}</div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "5px",
                            flexWrap: "wrap",
                          }}
                        >
                          {Array.from({ length: room.roomCapacity }, (_, i) => {
                            const isFilled = i < room.roomCapacityFilled;
                            return (
                              <div
                                key={i}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  borderRadius: "4px",
                                  backgroundColor: isFilled ? "#ccc" : "#007bff",
                                  color: "#fff",
                                  fontSize: "12px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  opacity: isFilled ? 0.6 : 1,
                                }}
                              >
                                {i + 1}
                              </div>
                            );
                          })}

                        </div>
                      </div>
                    );
                  })}
                <div

                  onClick={() => {
                    setFormData({ ...initialFromData });
                    setShowAddForm(true);
                    setSelectedRoom(null);

                  }}
                  className="center"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    padding: "10px",
                    width: "60px",
                    aspectRatio: "1/1",
                    textAlign: "center",
                    backgroundColor: "#007bff",
                    color: "#000",
                    cursor: "pointer",
                    position: "relative",
                    alignSelf: "center"

                  }}
                >

                  <i className="fa fa-plus" style={{ color: "#fff", fontSize: "30px", fontWeight: "900" }}></i>

                </div>
              </div>


            </DropDownBox>

            {(showAddForm || !isEmpty(selectedRoom)) && <DropDownBox style={{ marginBottom: "20px" }}>
              <h3 style={{ fontWeight: "600", marginBottom: "15px" }}>{showAddForm ? "Add Room" : "Update Room"}</h3>


              {(
                <>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                      rowGap: "20px",
                    }}
                  >
                    {formObj.map(({ label, name }) => {
                      if (showAddForm && name === "roomCapacityFilled") return "";
                      return (
                        <div

                          key={name}
                          style={{
                            flex: "1 1 calc(50% - 10px)",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label style={{ marginBottom: "5px" }}>{label}</label>
                          <Input
                            name={name}
                            value={formData[name]}
                            onChange={handleChange}
                            placeholder={`Enter ${label}`}
                            isError={!!error[name]}
                          />
                          {error[name] && (
                            <span style={{ color: "red", fontSize: "12px", marginTop: "3px" }}>
                              {error[name]}
                            </span>
                          )}
                        </div>
                      )
                    }

                    )}
                  </div>

                  <div style={{ display: "flex", gap: "15px", marginTop: "20px" }}>
                    <button className="confirm_button" onClick={handleSubmit} disabled={loader}>
                      {showAddForm ? "Save" : "Update"}
                    </button>
                    <button
                      className="cancel_button"
                      onClick={() => {
                        setShowAddForm(false);
                        setFormData({ ...initialFromData });
                        setError({});
                        setSelectedRoom(null);
                      }}
                      disabled={loader}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </DropDownBox>}
          </>
        )}
      </SidebarPopup>
    </div>
  );
}

export default TenantKyc;
